import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Icon } from '@unite-us/app-components';

function Header({ className }) {
  const { hint1246HideLgbtqPlusFilter } = useFlags();
  if (hint1246HideLgbtqPlusFilter) {
    return null;
  }

  const currentDate = new Date();

  return (
    <header className={classNames('app-logo bg-brand-blue', className)}>
      <div className="app-logo__screen">
        <Icon icon="LogoShieldText" color="white" style={{ svg: { width: '103px', height: '25px' } }} />
      </div>
      <div className="app-logo__print">
        <div className="app-logo__print-container">
          <div className="app-logo__print-logo">
            <Icon icon="LogoShieldText" color="black" style={{ svg: { width: '103px', height: '25px' } }} />
          </div>
          <div className="app-logo__print-date">
            {currentDate.toLocaleDateString()}
          </div>
        </div>
      </div>
    </header>
  );
}

Header.propTypes = {
  className: PropTypes.string,
};

Header.defaultProps = {
  className: '',
};

export default Header;
